import React, { useEffect } from "react";
import classes from "./Service.module.css";
import { useInView } from "react-intersection-observer";
import { useSpring, animated } from "react-spring";

function Service(props) {
  const [fade, api] = useSpring(() => ({
    from: { translateY: -100 },
    to: { translateY: 0 },
    config: { delay: 100, duration: 2000 },
  }));

  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      api.start({
        from: { translateY: 100 },
        to: { translateY: 0 },
        config: { delay: 100, duration: 1000 },
      });
    }
  }, [api, inView]);

  return (
    <animated.div className={classes.Service} ref={ref} style={fade}>
      <div className={classes.ServiceIcon}>
        <img src={props.src} alt={props.alt} />
      </div>
      <p className={classes.ServiceTitle}>{props.title}</p>
      <p className={classes.ServiceText}>{props.text}</p>
    </animated.div>
  );
}

export default Service;
